import { codeSplit, Controller, FetchOptions, FetchPageOptions } from 'bernie-core';
import { AnalyticsStore, ContextStore } from 'bernie-plugin-mobx';
import { PageData } from 'bernie-http';
import { generateRequestOptions, getPageName, PageId } from 'utility';
import { getNavigationIdFromQuery } from 'utility/navigation-identity';
import { getBexApiContext } from 'bernie-context';
import { VirtualAgentFlightCheckoutStore, VirtualAgentStore } from 'stores';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { ClientLogger } from 'bernie-client';
import { VirtualAgentCheckoutStatus } from '__generated__/api';

export class FlightServicingAgentController implements Controller {
  public pageId = PageId.FLIGHT_SERVICING_AGENT;
  public path = '/Flight-Servicing-Agent';
  public routeName = 'flight-servicing-agent';
  public bundles = [];
  public exact = true;
  public pendingPromises = [];
  /* istanbul ignore next */
  public component = codeSplit(
    () => import(/* webpackChunkName: "servicing-agent" */ '../views/flight-servicing-agent')
  );
  private logger = ClientLogger.getLoggerWithIdentifier('controller.flightServicingAgent');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fetch(options: FetchOptions): Promise<any> {
    const virtualAgentStore = options.stores.get<VirtualAgentStore>('virtualAgentStore');
    virtualAgentStore.isVirtualAgentClient = options?.query?.client === 'virtual-agent';
    if (options.isServer) {
      return this.fetchServerSide(options);
    }

    return Promise.resolve();
  }

  public fetchPageData(pageData: FetchPageOptions): Promise<PageData> {
    const title = 'Flight Servicing Agent Page';
    const query = pageData.query;
    const pageName = getPageName(this.pageId);
    const navigationId = getNavigationIdFromQuery(query);

    return Promise.resolve({ title, pageId: this.pageId, pageName, navigationId });
  }

  private async fetchServerSide(options: FetchOptions) {
    const virtualAgentFlightCheckoutStore = options.stores.get<VirtualAgentFlightCheckoutStore>(
      'virtualAgentFlightCheckoutStore'
    );
    virtualAgentFlightCheckoutStore.setCriteriaFromUrl(options);
    const bernieContext: ContextStore = options.stores.get<ContextStore>('context');
    const context = getBexApiContext(bernieContext);
    const variables = { context, ...virtualAgentFlightCheckoutStore.flightCheckoutInput };
    const analyticsStore = options.stores.get<AnalyticsStore>('analytics');
    const requestOptions = generateRequestOptions(options.request, options.isServer, this.pageId);

    try {
      const status: VirtualAgentCheckoutStatus = await virtualAgentFlightCheckoutStore.fetchResults(
        variables,
        requestOptions,
        analyticsStore
      );
      if (status.valueOf() === VirtualAgentCheckoutStatus.SUCCESS.valueOf()) {
        virtualAgentFlightCheckoutStore.responseStatus = 'SUCCESS';
      } else {
        virtualAgentFlightCheckoutStore.responseStatus = 'FAILED';
      }
    } catch (error) {
      virtualAgentFlightCheckoutStore.responseStatus = 'FAILED';
      this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'VIRTUAL_AGENT_FLIGHT_CHECKOUT'), error);
    }
  }
}
